import { toast } from 'react-toastify';

export const copyToClipboard = (text: string, sucessMessage: string): void => {
  navigator.clipboard.writeText(text);
  toast.success(sucessMessage, {
    position: toast.POSITION.TOP_LEFT,
  });
};
